import { QueryClient } from '@tanstack/react-query';
import { createContext } from 'react';

/** Default query client for the userAppState queries. */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      // Data only changes via explicit mutations — we can set the staleTime to infinity to prevent unnecessary refetches.
      staleTime: Infinity,
    },
    mutations: {
      retry: false,
    },
  },
});

/**
 * Exposes the recent and saved filters query client with a context.
 * @internal
 */
export const RecentAndSavedFiltersQueryClientContext =
  createContext(queryClient);
